import { window } from './facade/browser';
export function isBs3() {
    return window.__theme !== 'bs4';
}
//# sourceMappingURL=ng2-bootstrap-config.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/utils/ng2-bootstrap-config.js
// module id = ./node_modules/ngx-bootstrap/utils/ng2-bootstrap-config.js
// module chunks = 4